import { Formik } from "formik";
import React, { useState } from "react";
import {
  Button,
  ButtonGroup,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  InputGroup,
  Row,
} from "reactstrap";
import searchIcon from "../../../assets/icon/search.svg";
import columnSelectorIcon from "../../../assets/icon/column-selector.svg";
import ReactStrapTable from "components/reactStrapTable";
import claimsIcon from "../../../assets/icon/claims-purple.svg";
import dataEntryIcon from "../../../assets/icon/data-entry.svg";
// import iconStatus from "../../../assets/icon/pending.svg";
import resetAllIcon from "../../../assets/icon/resetall.svg";
import applyIcon from "../../../assets/icon/apply.svg";
import iconStatus from "../../../assets/icon/status-save-icon.svg";

import { useNavigate } from "react-router-dom";
import VerticalStatusPopover from "components/VerticalStatusPopover";
import MedicationShort from "components/MedicationShort";
import SearchButtons from "components/SearchButtons";
const rowData = [
  {
    id: 1,
    // check: <input type="checkbox" />,
    status: "Waiting ",
    due: "1:15 PM ",
    rx: "RX8001000 ",
    patient: "Doe, John ",
    medication: "Venlafaxine ER Tablet 150MG ",
    entered: "12:15 PM ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 2,
    // check: <input type="checkbox" />,
    status: "Due Soon",
    due: "1:19 PM ",
    rx: "RX8001002 ",
    patient: "Wright, Liam  ",
    medication: "Metformin HCL Tablet 500MG ",
    entered: "12:19 PM",
    // img: <img src={iconStatus} />,
  },

  {
    id: 3,
    // check: <input type="checkbox" />,
    status: "Due Soon",
    due: "1:23 PM ",
    rx: "RX8001003 ",
    patient: "Nelson, Jacob   ",
    medication: "Levothyroxine Sodium Tablet 75MCG  ",
    entered: "12:23 PM ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 4,
    // check: <input type="checkbox" />,
    status: "Due Soon",
    due: "1:27 PM  ",
    rx: "RX8001004 ",
    patient: "Clark, Daniel   ",
    medication: "Gabapentin Capsule 300MG   ",
    entered: "12:27 PM ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 5,
    // check: <input type="checkbox" />,
    status: "Due Soon",
    due: "1:31 PM  ",
    rx: "RX8001005",
    patient: "Scott, Benjamin   ",
    medication: "Sertraline HCL Tablet 100MG    ",
    entered: "12:31PM ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 6,
    // check: <input type="checkbox" />,
    status: "Due Soon",
    due: "1:35 PM  ",
    rx: "RX8001006 ",
    patient: "Hill, Liam   ",
    medication: "Omeprazole DR Capsule 20MG    ",
    entered: "12:35 PM  ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 6,
    // check: <input type="checkbox" />,
    status: "New",
    due: "1:39PM  ",
    rx: "RX8001007 ",
    patient: "White, James   ",
    medication: "Amlodipine Besylate Tablet 10MG    ",
    entered: "12:39 PM ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 8,
    // check: <input type="checkbox" />,
    status: "New",
    due: "1:43PM  ",
    rx: "RX8001008",
    patient: "King, Isabella   ",
    medication: "Losartan Potassium Tablet 50MG    ",
    entered: "12:43 PM  ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 9,
    // check: <input type="checkbox" />,
    status: "New",
    due: "1:47PM  ",
    rx: "RX8001009",
    patient: "Taylor, Daniel   ",
    medication: "Hydrochlorothiazide Tablet 25MG   ",
    entered: "12:47 PM  ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 10,
    // check: <input type="checkbox" />,
    status: "New",
    due: "1:51PM  ",
    rx: "RX8001010",
    patient: "Young, Benjamin ",
    medication: "Simvastatin Tablet 40MG     ",
    entered: "12:51 PM  ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 11,
    // check: <input type="checkbox" />,
    status: "New",
    due: "1:55PM  ",
    rx: "RX8001011",
    patient: "Lewis, Mia    ",
    medication: "Alprazolam Tablet 0.5MG    ",
    entered: "12:55 PM  ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 12,
    // check: <input type="checkbox" />,
    status: "New",
    due: "1:59 PM  ",
    rx: "RX8001011",
    patient: "Clark, Daniel   ",
    medication: "Escitalopram Oxalate Tablet 10MG    ",
    entered: "12:59 PM  ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 13,
    // check: <input type="checkbox" />,
    status: "New",
    due: "2:03 PM   ",
    rx: "RX8001012 ",
    patient: "Jackson, Jacob    ",
    medication: "Fluoxetine HCL Capsule 20MG  ",
    entered: "1:03 PM   ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 14,
    // check: <input type="checkbox" />,
    status: "New",
    due: "2:07 PM   ",
    rx: "RX8001013 ",
    patient: "Baker, Daniel    ",
    medication: "Citalopram HBR Tablet 20MG    ",
    entered: "1:07 PM    ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 15,
    // check: <input type="checkbox" />,
    status: "New",
    due: "2:11 PM   ",
    rx: "RX8001014  ",
    patient: "Walker, Aria    ",
    medication: "Clonazepam Tablet 0.5MG  ",
    entered: "1:11 PM    ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 16,
    // check: <input type="checkbox" />,
    status: "New",
    due: "2:15 PM    ",
    rx: "RX8001015 ",
    patient: "Kim, Harper    ",
    medication: "Tramadol HCL Tablet 50MG  ",
    entered: "1:15 PM   ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 17,
    // check: <input type="checkbox" />,
    status: "New",
    due: "2:19 PM   ",
    rx: "RX8001016  ",
    patient: "Wright, Harper    ",
    medication: "Trazodone HCL Tablet 100MG   ",
    entered: "1:19 PM ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 18,
    // check: <input type="checkbox" />,
    status: "New",
    due: "2:23 PM ",
    rx: "RX8001017   ",
    patient: "Adams, Emily   ",
    medication: "Duloxetine DR Capsule 30MG  ",
    entered: "1:23 PM  ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 19,
    // check: <input type="checkbox" />,
    status: "New",
    due: "2:27 PM  ",
    rx: "RX8001018  ",
    patient: "Kim, James   ",
    medication: "Bupropion HCL XL Tablet 150MG  ",
    entered: "1:27 PM  ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 20,
    // check: <input type="checkbox" />,
    status: "New",
    due: "2:31 PM  ",
    rx: "RX8001019   ",
    patient: "Harris, Sophia   ",
    medication: "Loratadine Tablet 10MG  ",
    entered: "1:31 PM   ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 21,
    // check: <input type="checkbox" />,
    status: "New",
    due: "2:35 PM   ",
    rx: "RX8001020   ",
    patient: "White, Aarav    ",
    medication: "Cetirizine HCL Tablet 10MG G  ",
    entered: "1:35 PM   ",
    // img: <img src={iconStatus} />,
  },

  {
    id: 22,
    // check: <input type="checkbox" />,
    status: "New",
    due: "2:39 PM    ",
    rx: "RX8001021   ",
    patient: "Young, Ethan  ",
    medication: "Prednisone Tablet 20MG   ",
    entered: "1:39 PM   ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 23,
    // check: <input type="checkbox" />,
    status: "New",
    due: "2:43 PM   ",
    rx: "RX8001022 ",
    patient: "Clark, Luna   ",
    medication: "Propranolol HCL Tablet 40MG ",
    entered: "1:43 PM   ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 17,
    // check: <input type="checkbox" />,
    status: "New",
    due: "2:47 PM  ",
    rx: "RX8001023  ",
    patient: "Allen, Daniel   ",
    medication: "Topiramate Tablet 25MG  ",
    entered: "1:47 PM   ",
    // img: <img src={iconStatus} />,
  },
  {
    id: 17,
    // check: <input type="checkbox" />,
    status: "New",
    due: "2:51 PM  ",
    rx: "RX8001024 ",
    patient: "Kim, Luna   ",
    medication: "Lamotrigine Tablet 100MG  ",
    entered: "1:51 PM   ",
    // img: <img src={iconStatus} />,
  },
];
const FinalReviewPage = () => {
  const [columnOpen, setColumnOpen] = useState(false);
  const [tableData, setTableData] = useState(rowData);
  const [updateData, setUpdateData] = useState([]);
  const [data, setData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigate = useNavigate();
  const [rSelected, setRSelected] = useState("off");

  const [check, setCheck] = useState([
    {
      selectall: "",
      due: "",
      status: "",
      rx: "",
      patient: "",
      medication: "",
      filltype: "",
      entered: "",
    },
  ]);

  const handleRowClick = (row) => {
    navigate(`/workflow-final-review-details/${row.id}`, { state: row });
  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    if (name === "selectall") {
      setCheck({
        selectall: checked,
        due: checked,
        rx: checked,
        patient: checked,
        medication: checked,
        filltype: checked,
        entered: checked,
        status: checked,
      });
    } else {
      setCheck((prevCheck) => {
        const updatedCheck = { ...prevCheck, [name]: checked };
        const allSelected = Object.values(updatedCheck).every(
          (val) => val === true
        );
        updatedCheck.selectall = allSelected;
        return updatedCheck;
      });
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows(rowData.map((row) => row.id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleSelectRow = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };
  const renderButtons = (rowData) => {
    return <VerticalStatusPopover row={rowData} />;
  };
  const RowCheckBox = (rowData) => {
    return (
      <div>
        {" "}
        <Input
          type="checkbox"
          onChange={() => handleSelectRow(rowData.id)}
          checked={selectedRows.includes(rowData.id)}
        />
      </div>
    );
  };
  const colHeader = [
    {
      dataField: "check",
      // width:120,
      text: (
        <div className="d-flex  align-items-center gap-2">
          <Input
            type="checkbox"
            onChange={handleSelectAll}
            checked={selectedRows.length === rowData.length}
          />
          All
        </div>
      ),
      cellRenderer: (rowData) => RowCheckBox(rowData),
      width: 60,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
      inputType: "checkbox",
    },

    {
      dataField: "status",
      text: "Order Status",
      show: true,
      sort: true,
      width: 110,
      cellRenderer: (rowData, col) => renderButtons(rowData),
    },
    {
      dataField: "due",
      text: "Due",
      show: true,
      sort: true,
      width: 90,
    },

    {
      dataField: "rx",
      text: "Rx Number",
      show: true,
      sort: true,
      width: 90,
    },
    {
      dataField: "patient",
      text: "Patient Name",
      show: true,
      sort: true,
      width: 100,
    },
    {
      dataField: "medication",
      text: "Medication",
      show: true,
      sort: true,
      width: 200,
      // cellRenderer: (rowData) => MedicationShort(rowData),
    },
    {
      dataField: "entered",
      text: "Entered",
      show: true,
      sort: true,
    },
  ];

  const filterColumns = () => {
    const columnIndexes = Object.entries(check)
      .filter(([key, value]) => value === true)
      .map(([key]) => {
        if (key === "status") return 1;
        if (key === "due") return 2;
        if (key === "rx") return 3;
        if (key === "patient") return 4;
        if (key === "medication") return 5;
        if (key === "filltype") return 6;
        if (key === "entered") return 7;
        return -1;
      })
      .filter((index) => index !== -1);
    return colHeader.filter((_, index) => columnIndexes.includes(index));
  };
  const filteredColData = filterColumns();
  const totalCount = [
    check.due,
    check.status,
    check.rx,
    check.patient,
    check.medication,
    check.filltype,
    check.entered,
  ].filter(Boolean).length;
  const handleSubmit = () => {
    setUpdateData(filteredColData.length > 0 ? filteredColData : colHeader);
    setColumnOpen(false);
  };
  // const handleNavigate = () => {
  //   navigate("/final-review-details");
  // };
  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };

  const tableFilterData = tableData.length
    ? tableData.map((patient) => {
        return {
          id: patient.id,
          status: (
            <>
              <VerticalStatusPopover
                patientId={patient.id} // Example prop: Pass patient ID
                patientStatus={patient.status}
              />
            </>
          ),
          // check: (
          //   <>
          //     <RowCheckBox
          //       patientId={patient.id} // Example prop: Pass patient ID
          //       patientStatus={patient.status}
          //     />
          //   </>
          // ),
          id: patient.id,
          patient: patient.patient,
          status: patient.status,
          due: patient.due,
          rx: patient.rx,
          medication: patient.medication,
          // medication: patient.medication,
          entered: patient.entered,
          //medication: user.username,
        };
      })
    : [
        {
          id: "",
          status: "",
          patient: "",
          due: "",
          rx: "",
          medication: "",
          entered: "",
        },
      ];

  return (
    <div className=" table-card scroll-table layout-alignment rounded bg-white pb-0">
      <div className="heading-text section-devider-border pb-2 mb-1">
        Final Review
      </div>
      <Row className="mt-2">
        <Col
          className="d-flex justify-content-start align-items-center "
          style={{ gap: "12px" }}
        >
          <SearchButtons
            InSize={280}
            placeHolder={"Search by Drug Name or Scan Rx"}
            data={tableData}
            row={rowData}
            setFilterData={setTableData}
          />
          <Dropdown
            isOpen={columnOpen}
            toggle={() => setColumnOpen(!columnOpen)}
          >
            <DropdownToggle className="clmn">
              <img src={columnSelectorIcon} alt="not available" />
              <span className="d-flex justify-content-center align-items-center gap-2">
                Columns{" "}
                {totalCount > 0 && (
                  <div className="totalcount">{totalCount}</div>
                )}
              </span>
            </DropdownToggle>
            <DropdownMenu className="drop-down-clm">
              <DropdownItem className="dropdownitem-border">
                <Input
                  type="checkbox"
                  name="selectall"
                  value={check.selectall}
                  onChange={handleCheck}
                  checked={check.selectall}
                />
                <span className="m-2">Select All</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="status"
                  value={check.status}
                  onChange={handleCheck}
                  checked={check.status}
                />
                <span className="m-2">Status</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border">
                <Input
                  type="checkbox"
                  name="due"
                  value={check.due}
                  onChange={handleCheck}
                  checked={check.due}
                />
                <span className="m-2">Due</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="patient"
                  value={check.patient}
                  onChange={handleCheck}
                  checked={check.patient}
                />
                <span className="m-2">Patient Name</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="rx"
                  value={check.rx}
                  onChange={handleCheck}
                  checked={check.rx}
                />
                <span className="m-2">Rx Number</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="filltype"
                  value={check.filltype}
                  onChange={handleCheck}
                  checked={check.filltype}
                />
                <span className="m-2">Fill Type</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="entered"
                  value={check.entered}
                  onChange={handleCheck}
                  checked={check.entered}
                />
                <span className="m-2">Entered</span>
              </DropdownItem>
              <div className="d-flex justify-content-center align-items-center p-2 drp-down-clm-item">
                <Button
                  onClick={() =>
                    setCheck({
                      selectall: false,
                      due: false,
                      medication: false,
                      rx: false,
                      patient: false,
                      filltype: false,
                      entered: false,
                      status: false,
                    })
                  }
                >
                  {" "}
                  <img src={resetAllIcon} alt="" /> Reset All
                </Button>
                <Button
                  color="primary"
                  onChange={handleCheck}
                  onClick={handleSubmit}
                >
                  {" "}
                  <img src={applyIcon} alt="" /> Apply
                </Button>
              </div>
            </DropdownMenu>
          </Dropdown>
          <span className="f-16 font-weight-600">Filter</span>
          <ButtonGroup className="filter-btn-group">
            <Button
              color="info"
              outline
              onClick={toggleFilter}
              active={rSelected === "off"}
            >
              OFF
            </Button>
            <Button
              color="info"
              outline
              active={rSelected === "on"}
              onClick={toggleFilter}
            >
              ON
            </Button>
          </ButtonGroup>
        </Col>
        <Col className="d-flex justify-content-end">
          <Button style={{ width: "203px", color: "#702C62" }}>
            <img src={claimsIcon} alt="not available" /> Back to Packaging
          </Button>

          <Button style={{ width: "210px" }} color="primary">
            <img src={dataEntryIcon} alt="not available" />
            Send to Data Entry
          </Button>
        </Col>
      </Row>
      <div fixed-height={rowData.length > 0 ? "fixed-height" : "default"}>
        <ReactStrapTable
          id="final-review"
          data={tableFilterData}
          row={rowData}
          columns={updateData.length > 0 ? updateData : colHeader}
          handleRowClick={handleRowClick}
          enablerowRouting={true}
          redRow={[0]}
          yellowRow={[1, 2, 3, 4, 5]}
        />
      </div>
    </div>
  );
};
export default FinalReviewPage;
